import { useState, useEffect } from "react";
import { Modal, Form, Button, message, InputNumber, Select } from "antd";
import SemesterService from "../../../services/SemesterService";
const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
    md: {
      span: 9,
    },
    lg: {
      span: 10,
    },
    xl: {
      span: 10,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
    md: {
      span: 15,
    },
    lg: {
      span: 14,
    },
    xl: {
      span: 14,
    },
  },
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};
export default function SemesterModalForm({
  isModalVisible,
  handleOk,
  handleCancel,
  semesterTarget = null,
}) {
  const [form] = Form.useForm();
  const [formField, setformField] = useState(null);

  useEffect(() => {
    if (semesterTarget) {
      setformField([
        { name: ["name"], value: semesterTarget.name },
        { name: ["year"], value: semesterTarget.year },
      ]);
    }
  }, [semesterTarget]);

  const onFinish = (values) => {
    let semesterR = { ...values };
    console.log('values',semesterR)
    if (semesterTarget) {
      semesterR.id = semesterTarget.id;
      SemesterService.updateSemester(semesterR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Semestre actualizado.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo actualizar el semestre. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message, 5);
        });
    } else {
      SemesterService.createSemester(semesterR)
        .then((res) => {
          if (res.data?.success) {
            message.success("Semestre registrado.", 3);
            handleOk();
          } else {
            message.error(
              "No se pudo registar el Semestre. " + res.data?.description,
              5
            );
          }
        })
        .catch((e) => {
          console.log("error", e.message);
          message.error("Hubo un error. " + e.message);
        });
    }
  };
  return (
    <Modal
      title="Registrar Semestre"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      footer={null}
    >
      <Form
        className="form"
        {...formItemLayout}
        form={form}
        fields={formField}
        name="register"
        onFinish={onFinish}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label="Nombre del Semestre"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el nombre del Semestre.",
              whitespace: true,
            },
          ]}
        >
          <Select>
                <Select.Option value={"I"}>
                    I
                </Select.Option>
                <Select.Option value={"II"}>
                    II
                </Select.Option>
            </Select>
        </Form.Item>
        <Form.Item
          name="year"
          label="Año"
          rules={[
            {
              required: true,
              message: "Por favor ingresa el Año",
            },
          ]}
        >
          <InputNumber min={2010} max={9999} />
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit">
            Aceptar
          </Button>
          <Button
            type="secondary"
            htmlType="button"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancelar
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
